<div class="container-fluid h-100 pb-3">
    <div class="row">
        <div class="col">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <span class="title">{{ content.title
                        }}</span>
                    <span class="sub-title" *ngIf="content.subTitle">{{ content.subTitle }}</span>
                </div>
                <ng-container *ngIf="!content.moveControlsToNextLine">
                    <div class="d-flex" *ngIf="filterArray?.length">
                        <ng-container *ngFor="let filter of filterArray; let i = index">
                            <ng-container *ngIf="filter.filterType === 'Year'">
                                <p-dropdown appendTo="body" [options]="years" [(ngModel)]="selectedYear"
                                    optionLabel="key" (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                                    styleClass="fb-dashboard-card-filter-dropdown year-filter"
                                    [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
                            </ng-container>
                            <ng-container *ngIf="filter.filterType === 'Month'">
                                <p-dropdown appendTo="body" [options]="months" [(ngModel)]="selectedMonth"
                                    optionLabel="key" (ngModelChange)="getDetailsPostFilter();" optionValue="value"
                                    styleClass="fb-dashboard-card-filter-dropdown month-filter"
                                    [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
                            </ng-container>
                            <ng-container *ngIf="['referenceLibrary'].includes(filter.filterType)">
                                <p-dropdown appendTo="body" [options]="filter.dropDownArray"
                                    [(ngModel)]="filter.selectedReferenceValue" optionLabel="name"
                                    (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                                    styleClass="fb-dashboard-card-filter-dropdown"
                                    [ngStyle]="{'width.px': filter.filterWidth}"
                                    [ngClass]="{'margin-left': i !== 0 && filterArray.length > 1}"></p-dropdown>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="content.moveControlsToNextLine">
        <ng-template [ngIf]="filterArray?.length">
            <div class="col" *ngFor="let filter of filterArray">
                <ng-container *ngIf="filter.filterType === 'Year'">
                    <p-dropdown appendTo="body" [options]="years" [(ngModel)]="selectedYear" optionLabel="key"
                        (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                        styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
                </ng-container>
                <ng-container *ngIf="filter.filterType === 'Month'">
                    <p-dropdown appendTo="body" [options]="months" [(ngModel)]="selectedMonth" optionLabel="key"
                        (ngModelChange)="getDetailsPostFilter();" optionValue="value"
                        styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
                </ng-container>
                <ng-container *ngIf="['referenceLibrary'].includes(filter.filterType)">
                    <ng-container *ngIf="!filter.multiSelect">
                        <p-dropdown appendTo="body" [options]="filter.dropDownArray"
                            [(ngModel)]="filter.selectedReferenceValue" optionLabel="name"
                            (ngModelChange)="getDetailsPostFilter()" optionValue="value"
                            styleClass="fb-dashboard-card-filter-dropdown w-100"></p-dropdown>
                    </ng-container>
                </ng-container>
            </div>
        </ng-template>
    </div>
    <div class="row" *ngIf="!content.moveControlsToNextLine">
        <div class="col-12">
            <p-divider styleClass="divider-m-5"></p-divider>
        </div>
    </div>
    <div class="row" *ngIf="chartOptions">
        <div class="col-12">
            <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
                style="width: 100%; display: block;"></highcharts-chart>
        </div>
    </div>
</div>